import { LabelProps } from '@components/label/src/label.types';

export const Label = ({ children, className, ...props }: LabelProps) => {
  return (
    <label className={className} {...props}>
      {children}
    </label>
  );
};
